import { render } from "./DbMathLevelItem.vue?vue&type=template&id=9c6f3a5a&ts=true"
import script from "./DbMathLevelItem.vue?vue&type=script&lang=ts"
export * from "./DbMathLevelItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__